// extracted by mini-css-extract-plugin
export default {"reset":"Heading__reset___2krB-"};